import React from 'react';
import PropTypes from 'prop-types';

import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';

import Container from '../../container/container';
import VerticalText from '../../verticalText/verticalText';

import theme, { mobileFirstMedia as media } from '../../../config/theme';
import {
  Grid,
  Aside,
  Navigation,
  NavigationItem,
  Link,
  IconWrapper,
  Content,
  Image,
} from './styles';
import Banner from '../../banner/banner';

const { colors } = theme;

const Page = ({
  parentSlug,
  links,
  pageTitle,
  image,
  bannerImage,
  children,
}) => (
  <>
    <Banner
      title={pageTitle}
      image={{ alt: bannerImage.alt, image: bannerImage.image }}
    />

    <Container
      css={`
        @media (${media.m}) {
          padding-left: 130px;
        }

        @media (min-width: 1690px) {
          padding-left: 25px;
        }
      `}
    >
      <VerticalText
        text={pageTitle}
        css={`
          position: sticky;
          top: 25px;
          display: inline-block;
        `}
      />

      <Grid css="margin-top: -50px;">
        <Aside>
          {links.length ? (
            <Navigation data-aos="fade-right" data-aos-delay="200">
              {links.filter(Boolean).map(({ slug, title }, index) => (
                <NavigationItem key={index}>
                  <Link
                    to={`/${parentSlug}/${slug}`}
                    title={`${title} - PRO-MEN`}
                    activeStyle={{ background: colors.primary }}
                  >
                    <IconWrapper>
                      <ArrowForwardIcon css="font-size: 15px;" />
                    </IconWrapper>
                    <span>{title}</span>
                  </Link>
                </NavigationItem>
              ))}
            </Navigation>
          ) : null}

          <div data-aos="fade-right" data-aos-delay="300">
            <Image
              fluid={image.image}
              alt={image.alt}
              imgStyle={{ objectPosition: 'right' }}
            />
          </div>
        </Aside>

        <Content>{children}</Content>
      </Grid>
    </Container>
  </>
);

Page.propTypes = {
  parentSlug: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired,
  pageTitle: PropTypes.string.isRequired,
  bannerImage: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Page;
